// extracted by mini-css-extract-plugin
export default {"cta":"rF-z","disabled":"sF-z"};